angular.module('dnecom')
    .controller('ColorProfileModalController', ColorProfileModalController);

ColorProfileModalController.$inject = ['$scope', '$uibModalInstance', 'colorProfile', '$http', 'notifications', 'ErrorBag', 'wizardModal', 'ProductAttributesUtils'];

function ColorProfileModalController($scope, $uibModalInstance, colorProfile, $http, notifications, ErrorBag, wizardModal, ProductAttributesUtils) {
    $scope.showColorSelector = false;
    $scope.codeInvalid = false;
    $scope.predefinedColors = ProductAttributesUtils.getDefaultColors();

    var recentColors = TemplateData.value('recentlyAddedColors');
    $scope.recentlyAddedColors = filterColors(recentColors, $scope.predefinedColors);
    $scope.customColors = {};

    $scope.colorProfile = angular.copy(colorProfile);
    $scope.colorProfile.valueNames = {};
    $scope.colorProfile.colors.forEach(function (color){
        $scope.colorProfile.valueNames[color.value] = color.name;
    });

    $scope.save = function() {
        $scope.serverErrors = {};
        $scope.loading = true;
        var colorProfile = $scope.colorProfile;
        var id = 0;
        if (colorProfile.hasOwnProperty('id')) {
            id = colorProfile.id;
        }

        var url = null;

        if (id) {
            url = Routing.generate('color_profile_update', {
                id: id
            });
        } else {
            url = Routing.generate('color_profile_add', {});
        }

        $http.put(url, colorProfile)
            .then(function(response) {
                $scope.loading = false;
                if (response.data.success) {
                    notifications.success('Color profile saved.');
                    $scope.colorProfile = response.data.colorProfile;

                    $uibModalInstance.close({
                        colorProfile: $scope.colorProfile
                    });
                } else {
                    notifications.danger(response.data.message);
                }
            }, function(response) {
                $scope.loading = false;
                if (response.status == 422) {
                    notifications.danger('Form contains invalid data.');

                    $scope.serverErrors = ErrorBag.from(response.data.errors);
                } else {
                    notifications.danger('Request error.');
                }
            });
    };

    $scope.$on('avuis:activate', function ($event, $select) {
        $scope.showColorSelector = true;
        $scope.codeInvalid = false;
    });

    $scope.selectColor = function (code, name) {
        if (!code || !/^([0-9a-f]{3}|[0-9a-f]{6})$/i.test(code)) {
            $scope.codeInvalid = true;
            return;
        }

        code = code.replace('#', '');

        if (!$scope.colorProfile.valueNames || Array.isArray($scope.colorProfile.valueNames)) {
            $scope.colorProfile.valueNames = {};
        }

        if (!name) {
            if ($scope.predefinedColors[code]) {
                name = $scope.predefinedColors[code];
            } else {
                name = code;
            }
        }

        $scope.customColors[code] = name;
        $scope.colorProfile.valueNames[code] = name;
        $scope.recentlyAddedColors[code] = name;

        var duplicated = false;
        $scope.colorProfile.colors.forEach(function (item) {
            if (item.value == code) {
                duplicated = true;
            }
        });

        if (duplicated) {
            notifications.danger('The color is already on the list.');
            return;
        }

        var newValue = {value: code, name: $scope.colorProfile.valueNames[code]};

        $scope.colorProfile.colors.push(newValue);

        $scope.showColorSelector = false;
    };

    $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.hideColorSelector = function() {
        $scope.showColorSelector = false;
        $scope.codeInvalid = false;
    };


    $scope.editColor = function(value, $event) {
        $event.preventDefault();
        $event.stopPropagation();

        if (!value.originalName) {
            value.originalName = value.name;
        }

        wizardModal.open({
            'templateUrl': 'colorNameModal.html',
            'size': 'md',
            'controller': 'ColorNameModalController',
            'resolve': {
                'colorName': function () {
                    return value.name;
                }
            }
        }).result.then(function (name) {
            if (!name) {
                return;
            }

            value.name = name;
            $scope.colorProfile.valueNames[value.value] = name;
        });
    };

    $scope.getColorName = function(code) {
        if ($scope.colorProfile.valueNames && $scope.colorProfile.valueNames[code]) {
            return $scope.colorProfile.valueNames[code];
        }
        return $scope.predefinedColors[code] || $scope.customColors[code] || ('#' + code);
    };

    function filterColors(recentlyAddedColors, predefinedColors) {
        var result = {};

        for (var key in recentlyAddedColors) {
            if (recentlyAddedColors.hasOwnProperty(key) && !predefinedColors.hasOwnProperty(key)) {
                result[key] = recentlyAddedColors[key];
            }

            if (Object.keys(result).length == 15) {
                break;
            }
        }

        return result;
    };
};
